import {
	ADVANCED_MANAGEMENT_SET_STEP,
	ADVANCED_MANAGEMENT_STORE_DATA,
	ADVANCED_MANAGEMENT_STORE_DATA_DOCUMENTS,
	ADVANCED_MANAGEMENT_SEARCH_BY_CPF_STARTED,
	ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED,
	ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_STARTED,
	ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_FINISHED,
	ADVANCED_MANAGEMENT_IS_MANAGER_STARTED,
	ADVANCED_MANAGEMENT_IS_MANAGER_FINISHED,
	ADVANCED_MANAGEMENT_STATUS_FILTERED,
	ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_STARTED,
	ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_FINISHED,
	ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_STARTED,
	ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_FINISHED,
	ADVANCED_MANAGEMENT_CLEAN_ERROR_CANCEL_RELATIONSHIP,
	ADVANCED_MANAGEMENT_IF_RENDER_MODAL_INVALID_CPF,
	ADVANCED_MANAGEMENT_SEND_DOCUMENTS_STARTED,
	ADVANCED_MANAGEMENT_SEND_DOCUMENTS_FINISHED,
	ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_CLEAN,
	ADVANCED_MANAGEMENT_SENDING_FILE
} from "../shared/constants";

const INITIAL_STATE = {
	dataRelationship: [],
	dataParticipantIndication: {},
	dataCurrentStep: 5,
	sendingFile: 0,
	dataToSend: {
		cpf: undefined,
		scannedStatement: undefined
	},
	dataToSendDocuments: {
		relationId: "",
		idManager: 0,
		idParticipant: 0,
		docs: []
	},
	hasParticipant: false,
	isInvalidCPF: false,
	renderModalInvalidCPF: false,
	isOneLessAttempt: false,
	isFailureLimitReached: false,
	isInvitationLimitReached: false,
	isInvitationSuccess: false,
	isLoading: {
		onSearchByCPF: false,
		onSearchByRelationship: false,
		onInviteParticipant: false,
		onCancelRelationship: false,
		onSendDocuments: false
	},
	filteredStatements: {
		label: "Todos",
		value: 0
	},
	hasDocuments: {
		hasIdFront: false,
		hasIdBack: false,
		hasSelfie: false
	},
	userManager: undefined,
	badgeCountPendent: 0,
	errorCancelRelationship: false
};

const AdvancedManagementReducer = (state = INITIAL_STATE, { type, payload } = action) => {
	switch (type) {
		case ADVANCED_MANAGEMENT_STATUS_FILTERED:
			return {
				...state,
				filteredStatements: payload
			};
		case ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onSearchByRelationship: true
				}
			};
		case ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_FINISHED:
			return {
				...state,
				...payload,
				isLoading: {
					...state.isLoading,
					onSearchByRelationship: false
				}
			};
		case ADVANCED_MANAGEMENT_IS_MANAGER_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					isManager: true
				}
			};
		case ADVANCED_MANAGEMENT_IS_MANAGER_FINISHED:
			return {
				...state,
				...payload,
				isLoading: {
					...state.isLoading,
					isManager: false
				}
			};
		case ADVANCED_MANAGEMENT_SEARCH_BY_CPF_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onSearchByCPF: true
				}
			};

		case ADVANCED_MANAGEMENT_IF_RENDER_MODAL_INVALID_CPF:
			return {
				...state,
				renderModalInvalidCPF: false
			};
		case ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED:
			return {
				...state,
				...payload,
				isLoading: {
					...state.isLoading,
					onSearchByCPF: false
				}
			};
		case ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onInviteParticipant: true
				}
			};
		case ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_FINISHED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onInviteParticipant: false
				},
				isInvitationSuccess: payload.isInvitationSuccess
				// dataRelationship: [...state.dataRelationship, payload]
			};
		case ADVANCED_MANAGEMENT_SENDING_FILE:
			return {
				...state,
				sendingFile: state.sendingFile + payload.sendingFile
			};
		case ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_CLEAN:
			return {
				...state,
				dataToSend: {
					cpf: undefined,
					scannedStatement: undefined
				},
				isInvitationSuccess: false,
				dataParticipantIndication: {}
			};
		case ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onCancelRelationship: payload
				}
			};
		case ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_FINISHED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onCancelRelationship: false
				},
				errorCancelRelationship: payload ? payload : false
				// dataRelationship: [...state.dataRelationship, payload]
			};
		case ADVANCED_MANAGEMENT_CLEAN_ERROR_CANCEL_RELATIONSHIP:
			return {
				...state,
				errorCancelRelationship: false
			};
		case ADVANCED_MANAGEMENT_SET_STEP:
			return {
				...state,
				dataCurrentStep: payload
			};
		case ADVANCED_MANAGEMENT_STORE_DATA:
			return {
				...state,
				dataToSend: {
					...state.data,
					...payload
				},
				isInvalidCPF: false,
				hasParticipant: false
			};
		case ADVANCED_MANAGEMENT_STORE_DATA_DOCUMENTS:
			if (!payload.docs) {
				payload.docs = [];
			}
			return {
				...state,
				dataToSendDocuments: {
					...state.dataToSendDocuments,
					...payload,
					docs: [...state.dataToSendDocuments.docs, ...payload.docs]
				}
			};
		case ADVANCED_MANAGEMENT_SEND_DOCUMENTS_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onSendDocuments: true
				}
			};
		case ADVANCED_MANAGEMENT_SEND_DOCUMENTS_FINISHED:
			return {
				...state,
				...payload,
				isLoading: {
					...state.isLoading,
					onSendDocuments: false
				}
			};
		default:
			return state;
	}
};

export default AdvancedManagementReducer;
